import '@affine/core/bootstrap/offline-network-guard';
import '@affine/core/bootstrap/browser';
import '@affine/core/bootstrap/cleanup';
import '@affine/component/theme';

import { sentry, tracker } from '@affine/track';

sentry.disable();
tracker.opt_out_tracking();
